import { render } from "./InfantilTable.vue?vue&type=template&id=26143407&scoped=true"
import script from "./InfantilTable.vue?vue&type=script&lang=js"
export * from "./InfantilTable.vue?vue&type=script&lang=js"

import "./InfantilTable.vue?vue&type=style&index=0&id=26143407&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26143407"]])

export default __exports__